import { SnackbarService } from './../shared/services/snackbar.service';
import { OnInit } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort, MatInput, } from '@angular/material';
import { BrokerageFeeService } from './brokerage-fee.service';
import { jsPDF } from "jspdf";
import { AuthService } from '../core/auth/auth.service';
import { Observable } from 'rxjs';
import { CONSTANTS } from '@app/shared/constants';
import { FormBuilder, FormControl } from '@angular/forms';
import { Spreadsheet } from '@app/shared/export/spreadsheet';
import { differenceInCalendarDays } from 'date-fns';
import { SessionService } from '../core/session/session.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DialogBrookageComponent } from './dialog-brookage/dialog-brookage.component';
import { LanguageService } from '@app/core/language/language.service';
import { TranslateService } from '@ngx-translate/core';
import { ExportHeaders } from './model/ExportHeaders';
var namePage = 'cadastro/taxaCorretagem';
var BrokerageFeeComponent = /** @class */ (function () {
    function BrokerageFeeComponent(languageService, translateService, formBuilder, authService, snackbarService, BrokerageFeeService, sessionService, snackBar, dialog) {
        var _this = this;
        this.languageService = languageService;
        this.translateService = translateService;
        this.formBuilder = formBuilder;
        this.authService = authService;
        this.snackbarService = snackbarService;
        this.BrokerageFeeService = BrokerageFeeService;
        this.sessionService = sessionService;
        this.snackBar = snackBar;
        this.dialog = dialog;
        this.jwt = this.sessionService.retrieveToken();
        this.dataSource = new MatTableDataSource();
        this.floatLabelControl = new FormControl('auto');
        this.minDate = new Date(1970, 1, 1);
        this.checkHeaderCliente = false;
        this.checkHeaderCorretora = false;
        this.hearderToExporPdf = new ExportHeaders();
        this.hearderToExporExcel = new ExportHeaders();
        this.lang = "";
        this.displayedColumns = ['carteira', 'operacao', 'contrato_emprestimo_acao', 'corretora', 'modalidade', 'papel', 'quantidade_acoes_boleta', 'qtd_acoes_contrato', 'data_pregao', 'status', 'valor_taxa_cliente', 'percentual_taxa_cliente', 'valor_taxa_corretora', 'percentual_taxa_corretora', 'CheckedBox_Corretora_Cliente'];
        this.typesModality = [
            { value: "0", viewValue: "D0" },
            { value: "1", viewValue: "D1" },
            { value: "B", viewValue: "Balcão" }
        ];
        this.isMobile = false;
        this.currentPage = 0;
        this.pageSizeOptions = [50, 100, 150];
        this.pageSize = this.pageSizeOptions[0];
        this.showLoading = false;
        this.authSubject = this.authService.getAuthModel();
        this.authSubject.subscribe(function (user) {
            _this.authUser = user;
        });
    }
    BrokerageFeeComponent.prototype.ngOnInit = function () {
        this.showLoading = true;
        this.isMobile = window.innerWidth <= 760;
        this.changeLang();
        this.buildFilterForm();
        this.loadStatusCombobox();
        //this.startGrid();
    };
    //Valida check box para envio de escolha de taxa
    BrokerageFeeComponent.prototype.vldCheckBox = function (event, table) {
        if (table.checked_cliente && (event.source.name === 'Nao' || event.source.name === 'CheckAllCliente')) {
            table.checked_corretora = false;
        }
        if (table.checked_corretora && (event.source.name === 'Sim' || event.source.name === 'CheckAllCorretora')) {
            table.checked_cliente = false;
        }
    };
    BrokerageFeeComponent.prototype.Checkedelement = function (chekname, table) {
        if (chekname === 'Sim' && table.status === "1") {
            table.checked_cliente = true;
            return true;
        }
        else if (chekname === 'Nao' && table.status === "2") {
            table.checked_corretora = true;
            return true;
        }
        return false;
    };
    //Carrega os Status do BackEnd
    BrokerageFeeComponent.prototype.loadStatusCombobox = function () {
        var _this = this;
        var parameters = this.getParameters();
        this.BrokerageFeeService.getStatus(parameters).subscribe(function (response) {
            _this.typeStatus = _this.BrokerageFeeService.jsonDataToComboboxStatuss(response.body);
            if (response.headers.get('x-jwt') && response.headers.get('x-jwt').toString().trim() != _this.jwt.trim()) {
                _this.BrokerageFeeService.setToken(response.headers.get('x-jwt'));
                _this.isWorkingDate();
            }
            _this.showLoading = false;
        }, function (err) {
            _this.showLoading = false;
            console.error(err);
            _this.handleError('Não foi possível carregar os status de demandas.');
            _this.typeStatus = [];
            if (err.headers.get('x-jwt') && err.headers.get('x-jwt').toString().trim() != _this.jwt.trim()) {
                _this.BrokerageFeeService.setToken(err.headers.get('x-jwt'));
            }
        });
    };
    // Limpa o formulario e realiza validações
    BrokerageFeeComponent.prototype.buildFilterForm = function () {
        this.filterForm = this.formBuilder.group({
            carteira: [''],
            data_inicio_negociacao: [{ value: '', disabled: false }],
            data_fim_negociacao: [{ value: '', disabled: false }],
            modalidade: [''],
            corretora: [''],
            status: [''],
            papel: ['']
        }, { validators: [startEndValidator, emptyStartDateValidator, emptyEndDateValidator, stardEndDateMaxRange] });
        if (this.isMobile) {
            this.filterForm.get('data_inicio_negociacao').enable();
            this.filterForm.get('data_fim_negociacao').enable();
        }
    };
    ;
    BrokerageFeeComponent.prototype.getActiveSortColumn = function (sort) {
        if (sort) {
            if (sort.active === 'status') {
                return 'STATUS_NAME';
            }
            else if (sort.active === 'database') {
                return 'CREATION_DATE_TIME';
            }
            else if (sort.active === 'unreadCommentNotification') {
                return 'UNREAD_COMMENT_NOTIFICATION';
            }
        }
        else {
            return 'UNREAD_COMMENT_NOTIFICATION';
        }
    };
    ;
    //Determina Ordenação das colunas
    BrokerageFeeComponent.prototype.getDirectionSort = function () {
        if (this.sort) {
            if (this.sort.direction.trim() !== '') {
                return this.sort.direction.toUpperCase().toString();
            }
            else {
                return this.sort.start.toUpperCase().toString();
            }
        }
        else {
            return 'DESC'.toString();
        }
    };
    ;
    //Realiza repasse de horario limite e valida o horario limite
    BrokerageFeeComponent.prototype.isWorkingDate = function () {
        var _this = this;
        try {
            var dateTimeNow_1 = new Date();
            this.BrokerageFeeService.getWorkTime(this.getParameters())
                .subscribe(function (resp) {
                _this.BrokerageFeeService.setToken(resp.headers.get('x-jwt'));
                var hour = resp.body['horario_limite'];
                var hoursdigits = hour.toString().split(':');
                _this.closingDate = new Date(dateTimeNow_1.getFullYear(), dateTimeNow_1.getMonth(), dateTimeNow_1.getDate(), parseInt(hoursdigits[0]), parseInt(hoursdigits[1]), parseInt(hoursdigits[2]));
                if (dateTimeNow_1 > _this.closingDate) {
                    if (_this.lang === 'pt-BR') {
                        _this.snackBar.open('Horario de operação ate as 20 Horas');
                    }
                    else {
                        _this.snackBar.open('The deadline for fee approval is 08:00pm');
                    }
                }
            }, function (error) {
                _this.showLoading = false;
                _this.BrokerageFeeService.setToken(error.headers.get('x-jwt'));
                console.error(error);
            });
        }
        catch (_a) {
        }
    };
    //Retorna todos os parametros da tela
    BrokerageFeeComponent.prototype.getParameters = function () {
        this.BrokerageFeePaginationParameters = {
            carteira: this.filterForm.value.carteira,
            data_inicio_negociacao: this.filterForm.value.data_inicio_negociacao,
            data_fim_negociacao: this.filterForm.value.data_fim_negociacao,
            modalidade: this.filterForm.value.modalidade,
            corretora: this.filterForm.value.corretora,
            status: this.filterForm.value.status,
            papel: this.filterForm.value.papel,
            gestorName: this.authUser.gestor,
            userName: this.authUser.name,
            pageIndex: this.currentPage,
            pageSize: this.pageSize,
            sortColumn: this.getActiveSortColumn(this.sort),
            sortOrder: this.getDirectionSort(),
            jwt: this.sessionService.retrieveToken(),
        };
        return this.BrokerageFeePaginationParameters;
    };
    ;
    //Tratamento de erro
    BrokerageFeeComponent.prototype.handleError = function (message) {
        this.snackbarService.showSnackbar(message, CONSTANTS.GLOBAL.OK.toUpperCase());
    };
    //Atualiza variaveis de paginação
    BrokerageFeeComponent.prototype.handlePage = function (e) {
        this.currentPage = e.pageIndex;
        this.pageSize = e.pageSize;
        this.searchBrokerageFee();
    };
    //Aplica o filtro e realiza validação se ocorreu erro no filtro
    BrokerageFeeComponent.prototype.applyFilter = function () {
        this.changeLang();
        var consistente = true;
        consistente = !(this.filterForm.value.status.length === 1 && this.filterForm.value.status[0] === 3);
        if (!this.filterForm.valid && consistente) {
            if (this.filterForm.hasError('emptyStartDate')) {
                if (this.lang === 'pt-BR') {
                    this.handleError('Preencha a data corretamente.');
                }
                else {
                    this.handleError('fill the value of date correctly.');
                }
            }
            else if (this.filterForm.hasError('emptyEndDate')) {
                if (this.lang === 'pt-BR') {
                    this.handleError('Preencha a data corretamente.');
                }
                else {
                    this.handleError('fill the value of to date correctly.');
                }
            }
            else if (this.filterForm.hasError('startEndInvalid')) {
                if (this.lang === 'pt-BR') {
                    this.handleError('A data inicial não pode ser maior que a data final.');
                }
                else {
                    this.handleError('The start date cannot be bigger than end date.');
                }
            }
            else if (this.filterForm.hasError('MaxRange')) {
                if (this.lang === 'pt-BR') {
                    this.handleError('O range de datas deve ser no máximo de 60 dias.');
                }
                else {
                    this.handleError('The max value between start date and end date cannot exced 60 days.');
                }
            }
            else {
                if (this.lang === 'pt-BR') {
                    this.handleError('O filtro possui campos inválidos.');
                }
                else {
                    this.handleError('The filter form Has Inavalid fields.');
                }
            }
        }
        else {
            this.searchBrokerageFee(true);
        }
    };
    ;
    //Inicializa com a Grid Preenchida contando com D-2
    BrokerageFeeComponent.prototype.startGrid = function () {
        var parameters = this.getParameters();
        parameters.data_fim_negociacao = new Date();
        var result = new Date();
        result.setDate(result.getDate());
        parameters.data_inicio_negociacao = result;
        this.listBrokerageFeeByParameters(parameters);
    };
    //Realiza validações e atualiza page index
    BrokerageFeeComponent.prototype.searchBrokerageFee = function (pageIndex) {
        var parameters = this.getParameters();
        if (pageIndex) {
            parameters.pageIndex = 0;
            if (this.paginator) {
                this.paginator.pageIndex = 0;
            }
        }
        if (!Array.isArray(parameters.modalidade)) {
            parameters.modalidade = [];
        }
        if (!Array.isArray(parameters.status)) {
            parameters.status = [];
        }
        this.listBrokerageFeeByParameters(parameters);
    };
    //Repasse de Satatus
    BrokerageFeeComponent.prototype.replaceStatus = function (status, typeStatus) {
        for (var i = 0; i < typeStatus.length; i++) {
            if (status === typeStatus[i].codigo_status_taxa_corretagem) {
                return typeStatus[i].nome_status_taxa_corretagem;
            }
        }
    };
    //Chama o Serviço que irá buscad no backend
    BrokerageFeeComponent.prototype.listBrokerageFeeByParameters = function (brokerageFeePaginationParameters) {
        var _this = this;
        if (brokerageFeePaginationParameters) {
            this.showLoading = true;
            this.checkHeaderCliente = false;
            this.checkHeaderCorretora = false;
            this.BrokerageFeeService.getBrokerageFeeList(brokerageFeePaginationParameters).subscribe(function (brokerageFeeResponse) {
                _this.changeLang();
                //Repassa o novo token
                _this.BrokerageFeeService.setToken(brokerageFeeResponse.headers.get('x-jwt'));
                if (brokerageFeeResponse.body.content) {
                    _this.dataSource = new MatTableDataSource(brokerageFeeResponse.body.content);
                    //Formata data para dd/mm/aaaa
                    _this.dataSource.data.forEach(function (resultMap) {
                        resultMap['data_pregao'] = resultMap['data_pregao'].toLocaleString(_this.lang).substr(0, 10);
                        resultMap['status_descricao'] = _this.replaceStatus(resultMap['status'], _this.typeStatus);
                        resultMap['valor_taxa_cliente'] = resultMap['valor_taxa_cliente'] ? resultMap['valor_taxa_cliente'].toLocaleString(_this.lang, { maximumFractionDigits: 2, minimumFractionDigits: 2 }) : '';
                        resultMap['percentual_taxa_cliente'] = resultMap['percentual_taxa_cliente'] ? resultMap['percentual_taxa_cliente'].toLocaleString(_this.lang, { maximumFractionDigits: 2, minimumFractionDigits: 2 }) : '';
                        resultMap['valor_taxa_corretora'] = resultMap['valor_taxa_corretora'] ? resultMap['valor_taxa_corretora'].toLocaleString(_this.lang, { maximumFractionDigits: 2, minimumFractionDigits: 2 }) : '';
                        resultMap['percentual_taxa_corretora'] = resultMap['percentual_taxa_corretora'] ? resultMap['percentual_taxa_corretora'].toLocaleString(_this.lang, { maximumFractionDigits: 2, minimumFractionDigits: 2 }) : '';
                        resultMap['checked_cliente'] = resultMap['status'] == '2' ? true : false;
                        resultMap['checked_corretora'] = resultMap['status'] == '1' ? true : false;
                    });
                    //Atualiza paginação
                    if (_this.paginator) {
                        _this.paginator.length = brokerageFeeResponse.body['totalElements'];
                    }
                    _this.showLoading = false;
                }
                else {
                    _this.dataSource = new MatTableDataSource();
                    _this.showLoading = false;
                }
            }, function (error) {
                _this.showLoading = false;
                _this.BrokerageFeeService.setToken(error.headers.get('x-jwt'));
                console.error(error);
            });
        }
    };
    //Abre o Dialog para menssagem em tela
    BrokerageFeeComponent.prototype.OpenDialog = function (title, text) {
        var conf = new MatDialogConfig();
        conf.data =
            {
                title: title,
                text: text
            };
        this.dialog.open(DialogBrookageComponent, conf);
        this.listBrokerageFeeByParameters(this.getParameters());
    };
    //Aplica as taxas selecionadas
    BrokerageFeeComponent.prototype.applyFees = function () {
        var _this = this;
        var parameters = this.getParameters();
        var dateTimeNow = new Date();
        if (dateTimeNow > this.closingDate) {
            this.snackBar.open('Horario de operação ate as 20 Horas');
        }
        else {
            this.showLoading = true;
            var arrErro_1 = [];
            var result = void 0;
            result = [{
                    'codLiquidacao': '',
                    'acao': ''
                }];
            result.pop();
            var arrToFind = this.dataSource.data.filter(function (x) { return x.checked_corretora === true || x.checked_cliente === true; });
            for (var index = 0; index < arrToFind.length; index++) {
                if (arrToFind[index]['status'] === 3) {
                    result.push({
                        'codLiquidacao': arrToFind[index]['codigo_liquidacao_corretagem'],
                        'acao': arrToFind[index]['checked_corretora'] === true ? 'aprovar' : 'reprovar'
                    });
                }
            }
            console.log(result);
            if (result.length <= 0) {
                this.OpenDialog('Não há taxas a serem aprovadas', '');
            }
            this.BrokerageFeeService.updateBrokerageFeeList(result, parameters)
                .subscribe(function (resp) {
                _this.BrokerageFeeService.setToken(resp.headers.get('x-jwt'));
                arrErro_1 = resp.body.filter(function (responseApplyFee) { return responseApplyFee['result'] === false; });
                _this.showLoading = false;
                if (arrErro_1.length > 0) {
                    _this.OpenDialog('Erro nos seguintes contratos:', arrErro_1);
                }
                else {
                    _this.OpenDialog('Sucesso', 'Todas as taxas selecionadas foram validadas !');
                }
            }, function (error) {
                _this.showLoading = false;
                _this.BrokerageFeeService.setToken(error.headers.get('x-jwt'));
                console.error(error);
            });
        }
    };
    //Limpa o Filtro
    BrokerageFeeComponent.prototype.clearFilter = function () {
        this.pageSize = this.pageSizeOptions[0];
        this.filterForm.reset();
        this.buildFilterForm();
    };
    //Export PDF
    BrokerageFeeComponent.prototype.downloadPDF = function () {
        var _this = this;
        this.changeLang();
        //  resultPDF2.this.hearderToExporPdf.Carteira  = '';
        var resultPDF = [];
        var headerExportPDF = [];
        if (this.lang === 'pt-BR') {
            resultPDF = [{
                    '%Cliente': '',
                    '%Corretora': '',
                    'Carteira': '',
                    'Contrato': '',
                    ' Corretora ': '',
                    'DataOperacao': '',
                    'Status': '',
                    'Modalidade': '',
                    'Operacao': '',
                    'Papel': '',
                    'Quantidade': '',
                    'Qtd Ctr': '',
                    'TaxaCliente': '',
                    'TaxaCorretora': ''
                }];
        }
        else {
            resultPDF = [{
                    'Client%': '',
                    'Broker%': '',
                    'Portifolio': '',
                    'Contract': '',
                    ' Broker ': '',
                    'Oper Date': '',
                    'Status': '',
                    'Modality': '',
                    'Transaction': '',
                    'Paper': '',
                    'Quantity': '',
                    'Qty Cont.': '',
                    'ClientValue': '',
                    'BrokerValue': ''
                }];
        }
        headerExportPDF = [
            this.hearderToExporPdf.Carteira,
            this.hearderToExporPdf.Contrato,
            this.hearderToExporPdf.Corretora,
            this.hearderToExporPdf.DataOperacao,
            this.hearderToExporPdf.Status,
            this.hearderToExporPdf.Modalidade,
            this.hearderToExporPdf.Opercao,
            this.hearderToExporPdf.Papel,
            this.hearderToExporPdf.Quantidade,
            this.hearderToExporPdf.Quantidade_ON6,
            this.hearderToExporPdf.TaxaCliente,
            this.hearderToExporPdf.TaxaCorretora,
            this.hearderToExporPdf.perCliente,
            this.hearderToExporPdf.perCorretora
        ];
        var rowLimit = 500;
        var pagination = this.getParameters();
        var img = new Image();
        var carteira, corretora, opercao, papel, modalidade, dtOperacao, contrato, percCliente, percCorretora, quantidade, quantidade_on6, vlrCliente, vlrCorretora;
        var doc = new jsPDF('landscape', 'px', 'a3', true);
        this.showLoading = true;
        img.src = './assets/img/logo-1x.jpg';
        pagination.pageIndex = 0;
        pagination.pageSize = rowLimit;
        pagination.status = pagination.status || [];
        resultPDF.pop();
        this.BrokerageFeeService.getBrokerageFeeExport(pagination)
            .subscribe(
        // (response: Array<BrokerageFeeTable>) => {
        function (response) {
            _this.BrokerageFeeService.setToken(response.headers.get('x-jwt'));
            var arrBrook = response.body;
            arrBrook.forEach(function (resultMap) {
                if (_this.lang === 'pt-BR') {
                    resultPDF.push({
                        'Carteira': resultMap['carteira'] === null ? carteira = '-' : carteira = resultMap['carteira'].toString().trim(),
                        ' Corretora ': resultMap['corretora'] === null ? corretora = '-' : corretora = resultMap['corretora'].toString().trim(),
                        'Operacao': resultMap['operacao'] === null ? opercao = '-' : opercao = resultMap['operacao'].toString().trim(),
                        'Papel': resultMap['papel'] === null ? papel = '' : papel = resultMap['papel'].toString().trim(),
                        'Modalidade': resultMap['modalidade'] === null ? modalidade = '-' : modalidade = resultMap['modalidade'].toString().trim(),
                        'DataOperacao': resultMap['data_pregao'] === null ? dtOperacao = '-' : dtOperacao = resultMap['data_pregao'].substr(0, 10),
                        'Contrato': resultMap['contrato_emprestimo_acao'] === null ? contrato = '-' : contrato = resultMap['contrato_emprestimo_acao'].toString().trim(),
                        '%Cliente': resultMap['percentual_taxa_cliente'] === null ? percCliente = '-' : percCliente = Number(resultMap['percentual_taxa_cliente']).toLocaleString('pt-BR', { maximumFractionDigits: 2, minimumFractionDigits: 2 }),
                        '%Corretora': resultMap['percentual_taxa_corretora'] === null ? percCorretora = '-' : percCorretora = Number(resultMap['percentual_taxa_corretora']).toLocaleString('pt-BR', { maximumFractionDigits: 2, minimumFractionDigits: 2 }),
                        'Quantidade': resultMap['quantidade_acoes_boleta'] === null ? quantidade = '-' : quantidade = resultMap['quantidade_acoes_boleta'].toString().trim(),
                        'Qtd Ctr': resultMap['qtd_acoes_contrato'] === null ? quantidade_on6 = '-' : quantidade_on6 = resultMap['qtd_acoes_contrato'].toString().trim(),
                        'TaxaCliente': resultMap['valor_taxa_cliente'] === null ? vlrCliente = '-' : vlrCliente = Number(resultMap['valor_taxa_cliente']).toLocaleString('pt-BR', { maximumFractionDigits: 2, minimumFractionDigits: 2 }),
                        'TaxaCorretora': resultMap['valor_taxa_corretora'] === null ? vlrCorretora = '-' : vlrCorretora = Number(resultMap['valor_taxa_corretora']).toLocaleString('pt-BR', { maximumFractionDigits: 2, minimumFractionDigits: 2 }),
                        'Status': resultMap['status'] === null ? status = '-' : status = _this.BrokerageFeeService.ChangeLang(Number(resultMap['status'])),
                    });
                }
                else {
                    resultPDF.push({
                        'Portifolio': resultMap['carteira'] === null ? carteira = '-' : carteira = resultMap['carteira'].toString().trim(),
                        ' Broker ': resultMap['corretora'] === null ? corretora = '-' : corretora = resultMap['corretora'].toString().trim(),
                        'Transaction': resultMap['operacao'] === null ? opercao = '-' : opercao = resultMap['operacao'].toString().trim(),
                        'Paper': resultMap['papel'] === null ? papel = '' : papel = resultMap['papel'].toString().trim(),
                        'Modality': resultMap['modalidade'] === null ? modalidade = '-' : modalidade = resultMap['modalidade'].toString().trim(),
                        'Oper Date': resultMap['data_pregao'] === null ? dtOperacao = '-' : dtOperacao = resultMap['data_pregao'].substr(0, 10),
                        'Contract': resultMap['contrato_emprestimo_acao'] === null ? contrato = '-' : contrato = resultMap['contrato_emprestimo_acao'].toString().trim(),
                        'Client%': resultMap['percentual_taxa_cliente'] === null ? percCliente = '-' : percCliente = Number(resultMap['percentual_taxa_cliente']).toLocaleString('pt-BR', { maximumFractionDigits: 2, minimumFractionDigits: 2 }),
                        'Broker%': resultMap['percentual_taxa_corretora'] === null ? percCorretora = '-' : percCorretora = Number(resultMap['percentual_taxa_corretora']).toLocaleString('pt-BR', { maximumFractionDigits: 2, minimumFractionDigits: 2 }),
                        'Quantity': resultMap['quantidade_acoes_boleta'] === null ? quantidade = '-' : quantidade = resultMap['quantidade_acoes_boleta'].toString().trim(),
                        'Qty Cont.': resultMap['qtd_acoes_contrato'] === null ? quantidade_on6 = '-' : quantidade_on6 = resultMap['qtd_acoes_contrato'].toString().trim(),
                        'ClientValue': resultMap['valor_taxa_cliente'] === null ? vlrCliente = '-' : vlrCliente = Number(resultMap['valor_taxa_cliente']).toLocaleString('pt-BR', { maximumFractionDigits: 2, minimumFractionDigits: 2 }),
                        'BrokerValue': resultMap['valor_taxa_corretora'] === null ? vlrCorretora = '-' : vlrCorretora = Number(resultMap['valor_taxa_corretora']).toLocaleString('pt-BR', { maximumFractionDigits: 2, minimumFractionDigits: 2 }),
                        'Status': resultMap['status'] === null ? status = '-' : status = _this.BrokerageFeeService.ChangeLang(Number(resultMap['status'])),
                    });
                }
            });
            doc.setLanguage('pt-BR');
            doc.addImage('./assets/img/logo-3x.jpg', 'jpg', 850, 10, 20, 20, 'Logo', 'NONE', 0);
            doc.table(8, 40, resultPDF, _this.createHeaders(headerExportPDF), {
                fontSize: 11.5,
                printHeaders: true,
                autoSize: true,
                headerBackgroundColor: '#EC7406'
            });
            doc.save('TaxadeCorretagem.pdf');
            _this.showLoading = false;
        }, function (error) {
            _this.showLoading = false;
            console.error(error);
        });
    };
    //Criacao de Header para export do PDF.
    BrokerageFeeComponent.prototype.createHeaders = function (keys) {
        return keys.map(function (key) { return ({
            'name': key,
            'prompt': key,
            'width': 40,
            'align': 'center',
            'padding': 0
        }); });
    };
    //Export Excel
    BrokerageFeeComponent.prototype.downloadExcel = function () {
        var _this = this;
        this.changeLang();
        this.showLoading = true;
        var rowLimit = 15000;
        var parameters = this.getParameters();
        parameters.pageIndex = 0;
        parameters.pageSize = rowLimit;
        parameters.status = parameters.status || [];
        this.BrokerageFeeService.getBrokerageFeeExport(parameters)
            .subscribe(function (response) {
            //Set novo token
            _this.BrokerageFeeService.setToken(response.headers.get('x-jwt'));
            var arrBrook = response.body;
            var tableToExport = _this.convertToSpreadsheet(arrBrook);
            if (tableToExport.length >= rowLimit) {
                _this.showLimitToExportMessage(rowLimit);
            }
            var spreadsheetGenerator = new Spreadsheet('Taxa de Corretagem', tableToExport);
            spreadsheetGenerator.generateSpreadsheet();
            _this.showLoading = false;
        }, function (error) {
            _this.showLoading = false;
            console.error(error);
        });
    };
    //Coversao de campos para export
    BrokerageFeeComponent.prototype.convertToSpreadsheet = function (table) {
        var _this = this;
        if (this.lang === 'pt-BR') {
            return table.map(function (brokerageFee) { return ({
                'Carteira': brokerageFee.carteira,
                'Código da Operação': brokerageFee.operacao,
                'Número do Contrato': brokerageFee.contrato_emprestimo_acao,
                'Código da Corretora': brokerageFee.corretora,
                'Modalidade da Boleta': brokerageFee.modalidade,
                'Papel': brokerageFee.papel,
                'Quantidade de Ações': brokerageFee.quantidade_acoes_boleta,
                'Quantidade de Ações ON6': brokerageFee.qtd_acoes_contrato,
                'Data Operação': brokerageFee.data_pregao,
                'Status': brokerageFee.status_descricao === null ? brokerageFee.status_descricao = '-' : brokerageFee.status_descricao = brokerageFee.status_descricao.toString().trim(),
                'Taxa Enviada pelo Cliente': brokerageFee.valor_taxa_cliente,
                'Percentual Enviado pelo Cliente': brokerageFee.percentual_taxa_cliente,
                'Taxa Enviada pela Corretora': brokerageFee.valor_taxa_corretora,
                'Percentual Enviado pela Corretora': brokerageFee.percentual_taxa_corretora,
            }); });
        }
        else {
            return table.map(function (brokerageFee) { return ({
                'Portifolio': brokerageFee.carteira,
                'Transaction': brokerageFee.operacao,
                'Contract': brokerageFee.contrato_emprestimo_acao,
                'Broker': brokerageFee.corretora,
                'Modality': brokerageFee.modalidade,
                'Paper': brokerageFee.papel,
                'Quantity': brokerageFee.quantidade_acoes_boleta,
                'Quantit Cont': brokerageFee.qtd_acoes_contrato,
                'Transaction Date': brokerageFee.data_pregao,
                'Status': brokerageFee.status_descricao === null ? brokerageFee.status_descricao = '-' : brokerageFee.status_descricao = _this.BrokerageFeeService.ChangeLang(brokerageFee.status),
                'Client fee Value': brokerageFee.valor_taxa_cliente,
                'Client %': brokerageFee.percentual_taxa_cliente,
                'Broker fee Value': brokerageFee.valor_taxa_corretora,
                'Broker %': brokerageFee.percentual_taxa_corretora,
            }); });
        }
    };
    BrokerageFeeComponent.prototype.showLimitToExportMessage = function (limit) {
        this.handleError(this.messageExportLimit(limit));
    };
    BrokerageFeeComponent.prototype.messageExportLimit = function (limit) {
        return "O limite para a exporta\u00E7\u00E3o \u00E9 de " + limit + " registros,"
            + (" apenas os primeiros " + limit + " ser\u00E3o exibidos, voc\u00EA pode refazer a busca para")
            + ' exportar todas as demandas que necessita visualizar.';
    };
    //Desabilita CheckBox
    BrokerageFeeComponent.prototype.disableCheckBox = function (table) {
        if (table.codigo_liquidacao_corretagem && table.status.toString().trim() === '3') {
            return false;
        }
        else {
            return true;
        }
    };
    ;
    BrokerageFeeComponent.prototype.changeLang = function () {
        this.lang = localStorage.getItem('lang') === 'br' ? 'pt-BR' : 'en-US';
        if (this.lang === 'pt-BR') {
            //pdf headers
            this.hearderToExporPdf.Carteira = 'Carteira';
            this.hearderToExporPdf.Contrato = 'Contrato';
            this.hearderToExporPdf.Corretora = ' Corretora ';
            this.hearderToExporPdf.DataOperacao = 'DataOperacao';
            this.hearderToExporPdf.Status = 'Status';
            this.hearderToExporPdf.Modalidade = 'Modalidade';
            this.hearderToExporPdf.Opercao = 'Operacao';
            this.hearderToExporPdf.Papel = 'Papel';
            this.hearderToExporPdf.Quantidade = 'Quantidade';
            this.hearderToExporPdf.Quantidade_ON6 = 'Qtd Ctr';
            this.hearderToExporPdf.TaxaCliente = 'TaxaCliente';
            this.hearderToExporPdf.TaxaCorretora = 'TaxaCorretora';
            this.hearderToExporPdf.perCliente = '%Cliente';
            this.hearderToExporPdf.perCorretora = '%Corretora';
            //excel headers
            this.hearderToExporExcel.Carteira = 'Carteira';
            this.hearderToExporExcel.Opercao = 'Código da Operação';
            this.hearderToExporExcel.Contrato = 'Número do Contrato';
            this.hearderToExporExcel.Corretora = 'Código da Corretora';
            this.hearderToExporExcel.Modalidade = 'Modalidade da Boleta';
            this.hearderToExporExcel.Papel = 'Papel';
            this.hearderToExporExcel.Quantidade = 'Quantidade de Ações';
            this.hearderToExporExcel.Quantidade_ON6 = 'Quantidade de Ações Contrato';
            this.hearderToExporExcel.DataOperacao = 'Data Operação';
            this.hearderToExporExcel.Status = 'Status';
            this.hearderToExporExcel.TaxaCliente = 'Taxa Enviada pelo Cliente';
            this.hearderToExporExcel.perCliente = 'Percentual Enviado pelo Cliente';
            this.hearderToExporExcel.TaxaCorretora = 'Taxa Enviada pela Corretora';
            this.hearderToExporExcel.perCorretora = 'Percentual Enviado pela Corretora';
        }
        else {
            this.hearderToExporPdf.Carteira = 'Portifolio';
            this.hearderToExporPdf.Contrato = 'Contract';
            this.hearderToExporPdf.Corretora = ' Broker ';
            this.hearderToExporPdf.DataOperacao = 'Oper Date';
            this.hearderToExporPdf.Status = 'Status';
            this.hearderToExporPdf.Modalidade = 'Modality';
            this.hearderToExporPdf.Opercao = 'Transaction';
            this.hearderToExporPdf.Papel = 'Paper';
            this.hearderToExporPdf.Quantidade = 'Quantity';
            this.hearderToExporPdf.Quantidade_ON6 = 'Qty Cont.';
            this.hearderToExporPdf.TaxaCliente = 'ClientValue';
            this.hearderToExporPdf.TaxaCorretora = 'BrokerValue';
            this.hearderToExporPdf.perCliente = 'Client%';
            this.hearderToExporPdf.perCorretora = 'Broker%';
            this.hearderToExporExcel.Carteira = 'Portifolio';
            this.hearderToExporExcel.Contrato = 'Contract';
            this.hearderToExporExcel.Corretora = ' Broker ';
            this.hearderToExporExcel.DataOperacao = 'Oper Date';
            this.hearderToExporExcel.Status = 'Status';
            this.hearderToExporExcel.Modalidade = 'Modality';
            this.hearderToExporExcel.Opercao = 'Transaction';
            this.hearderToExporExcel.Papel = 'Paper';
            this.hearderToExporExcel.Quantidade = 'Quantity';
            this.hearderToExporExcel.Quantidade_ON6 = 'Qty Cont.';
            this.hearderToExporExcel.TaxaCliente = 'ClientValue';
            this.hearderToExporExcel.TaxaCorretora = 'BrokerValue';
            this.hearderToExporExcel.perCliente = 'Client%';
            this.hearderToExporExcel.perCorretora = 'Broker%';
        }
    };
    ;
    // Marca todos o check box
    BrokerageFeeComponent.prototype.checkAll = function (event) {
        this.dataSource.data
            .forEach(function (element) {
            if (event.source.name === 'CheckAllCliente' && element['codigo_liquidacao_corretagem'] !== null && element['status'].toString().trim() === '3') {
                element['checked_cliente'] = event.source.checked;
                if (element['checked_cliente'] === true) {
                    element['checked_corretora'] = !event.source.checked;
                }
            }
            else if (event.source.name === 'CheckAllCorretora' && element['codigo_liquidacao_corretagem'] !== null && element['status'].toString().trim() === '3') {
                element['checked_corretora'] = event.source.checked;
                if (element['checked_cliente'] === true) {
                    element['checked_cliente'] = !event.source.checked;
                }
            }
        });
        if (event.source.name === 'CheckAllCliente' && this.checkHeaderCorretora) {
            this.checkHeaderCorretora = false;
        }
        if (event.source.name === 'CheckAllCorretora' && this.checkHeaderCliente) {
            this.checkHeaderCliente = false;
        }
    };
    ;
    return BrokerageFeeComponent;
}());
export { BrokerageFeeComponent };
//Valida se a data Final é maior do que a data inicial
export var startEndValidator = function (control) {
    var startDate = control.get('data_inicio_negociacao');
    var endDate = control.get('data_fim_negociacao');
    return startDate && startDate.value && endDate && endDate.value && startDate.value > endDate.value ? { 'startEndInvalid': true } : null;
};
//Valida se as data inicial esta vazia
export var emptyStartDateValidator = function (control) {
    var startDate = control.get('data_inicio_negociacao');
    return (!startDate || !startDate.value) ? { 'emptyStartDate': true } : null;
};
//Valida se as data final esta vazia
export var emptyEndDateValidator = function (control) {
    var endDate = control.get('data_fim_negociacao');
    return (!endDate || !endDate.value) ? { 'emptyEndDate': true } : null;
};
//Valida se a data inicial nao ultrapassa 60 dias da data final
export var stardEndDateMaxRange = function (control) {
    var result = differenceInCalendarDays(new Date(control.get('data_fim_negociacao').value), new Date(control.get('data_inicio_negociacao').value));
    return (result > 60 && control.get('status').value != 3) ? { 'MaxRange': true } : null;
};
